import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogCancelamento = ({ isDevolucao, onClose, ...props }) => {
    const [loading, setLoading] = useState(false);
    const form = useFormik({
        initialValues: {
            justificacao: ''
        },
        validationSchema: yup.object({
            justificacao: yup.string().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>{isDevolucao ? 'Devolução' : 'Cancelamento'} de encomenda</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField InputProps={{
            endAdornment: <React.Fragment>{loading ? <CircularProgress color='inherit' size={20}/> : null}</React.Fragment>
        }} label={`Motivo ${isDevolucao ? 'da devolução' : 'de cancelamento'} *`} name='justificacao' defaultValue={form.values?.justificacao} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.justificacao && Boolean(form.errors.justificacao)} helperText={form.touched.justificacao && form.errors.justificacao}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogCancelamento;
